import React from "react";
import LegalPage from "./LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" subtitle="Legal" testid="privacy-page">
      <p>
        We respect your privacy. This Privacy Policy explains what personal data we collect, how we use it,
        and the choices available to you.
      </p>

      <h2>1. Data We Collect</h2>
      <ul>
        <li>
          <strong>Account data:</strong> name, email, password hash (bcrypt), Google profile picture (if you
          sign in with Google).
        </li>
        <li>
          <strong>Payment data:</strong> Razorpay subscription ID, plan ID, payment status — <em>not</em> the
          card/UPI number. Payment instruments are handled directly by Razorpay (PCI-DSS compliant).
        </li>
        <li>
          <strong>Usage data:</strong> watchlist entries, triggered alerts, AI fundamental requests, feature
          preferences.
        </li>
        <li>
          <strong>Technical data:</strong> IP address, browser user agent, timestamps — used to secure the
          Service and prevent abuse.
        </li>
      </ul>

      <h2>2. How We Use Data</h2>
      <ul>
        <li>To provide and personalise the Service (e.g. show your watchlist, send alerts).</li>
        <li>To process payments via Razorpay and maintain your subscription.</li>
        <li>To improve signal quality, detect bugs, and monitor system health.</li>
        <li>To communicate important service notices (e.g. renewal receipts, policy changes).</li>
      </ul>

      <h2>3. Third-Party Services</h2>
      <ul>
        <li>
          <strong>Razorpay</strong> — payment processing. Governed by Razorpay&apos;s privacy policy.
        </li>
        <li>
          <strong>Google</strong> — optional OAuth sign-in. Only email, name and profile picture are used.
        </li>
        <li>
          <strong>Yahoo Finance (yfinance)</strong> — public market data; no personal data is shared with it.
        </li>
        <li>
          <strong>Google Gemini (via Emergent)</strong> — for AI fundamental analysis. Only the stock ticker
          and its publicly available fundamentals are sent, never your personal data.
        </li>
      </ul>

      <h2>4. Data Retention</h2>
      <p>
        Account and billing records are retained for as long as your account is active and for up to 7 years
        thereafter to comply with tax and accounting laws. You may request deletion at any time; we will
        delete or anonymise personal data except what we are required to keep.
      </p>

      <h2>5. Your Rights</h2>
      <ul>
        <li>Access, correct, or delete your personal data by emailing <span className="font-mono">breakoutscanner1987@gmail.com</span>.</li>
        <li>Withdraw consent (e.g. cancel subscription, disable Google sign-in).</li>
        <li>Lodge a complaint with the Data Protection Board of India.</li>
      </ul>

      <h2>6. Security</h2>
      <p>
        Data in transit is protected with TLS. Passwords are stored as bcrypt hashes (never plaintext). Access
        tokens use httpOnly cookies plus short-lived JWTs. We follow commercially reasonable measures but
        cannot guarantee absolute security.
      </p>

      <h2>7. Cookies</h2>
      <p>
        We use strictly necessary cookies for authentication (access token, session token) and a{" "}
        <span className="font-mono">theme</span> preference in localStorage. We do not use third-party
        advertising cookies.
      </p>

      <h2>8. Contact</h2>
      <p>
        Privacy queries: <span className="font-mono">breakoutscanner1987@gmail.com</span>.
      </p>
    </LegalPage>
  );
}
